module.exports = __webpack_public_path__ + "img/de-product-classify_img_3.611ca47e.jpg";